export const clarityData = {
  site: "https://claritycooperative.com",
  name: "Clarity Cooperative",
  email: "hello@claritycooperative.com",
  logo: "https://api.claritycooperative.com/img/og_img.png",
  logoH: "150",
  logoW: "300",
};

const convertKey = (key) => {
  return key
    .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
      return ":" + y.toLowerCase();
    })
    .replace(/^_/, "");
};

export const convertTwitterMeta = (twitter) => {
  return Object.keys(twitter || {}).map((key) => <meta name={`twitter:${convertKey(key)}`} content={twitter[key]}></meta>);
};

export const convertOgMeta = (og) => {
  return Object.keys(og || {}).map((key) => <meta key={og[key]} property={`og:${convertKey(key)}`} content={og[key]}></meta>);
};

export const scriptSchema = (jsonOragnisationn, name) => {
  return (
    <script data-scheme={name} type="application/ld+json">
      {JSON.stringify(jsonOragnisationn)}
    </script>
  );
};
